import { TableFilterOptionItem } from '~/components/Table/components/filters/types';

export enum WorkbenchFiltersType {
  STATUS = 'status',
  TYPE = 'type',
  CREATED_ON = 'createdOn',
  CREATED_BY = 'createdBy',
}

export type TableSearchChangeCallback = (search: string) => void;

export type WorkbenchFilters = {
  [WorkbenchFiltersType.STATUS]: TableFilterOptionItem[];
  [WorkbenchFiltersType.TYPE]: TableFilterOptionItem[];
  [WorkbenchFiltersType.CREATED_ON]: TableFilterOptionItem[];
  [WorkbenchFiltersType.CREATED_BY]: TableFilterOptionItem[];
};
